import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  readonly noConnectionError = 'No Internet Connection';
  constructor() {}

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        // No Internet connection
        console.error(this.noConnectionError);
      }
      // Http errors
      const errMsg = error.message
        ? error.message
        : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';

      console.error(errMsg);
    }
    console.error(error);
  }
}
